module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v("New User")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png")
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "long-span",
    class: {
      'es5': _vm.isIt || _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('uername')) + "(email): "), _c('img', {
    staticClass: "star",
    attrs: {
      "src": require("../../assets/icon_star.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item portrait"
  }, [_c('span', {
    staticClass: "porSpan"
  }, [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": '/api/v2.0/person/' + _vm.uid + '/portrait',
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + " "), _c('img', {
    staticClass: "star",
    attrs: {
      "src": require("../../assets/icon_star.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('gender')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.gender),
      expression: "profile.gender"
    }],
    staticClass: "gender",
    attrs: {
      "id": "gender"
    },
    domProps: {
      "value": _vm.profile.gender
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GDRNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRM"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GDRF"
    }
  }, [_vm._v(_vm._s(_vm.$t('GDRF')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.height),
      expression: "profile.height"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.height
    },
    domProps: {
      "value": (_vm.profile.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('cm')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('weight')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.weight),
      expression: "profile.weight"
    }],
    staticClass: "height",
    attrs: {
      "placeholder": _vm.profile.weight
    },
    domProps: {
      "value": (_vm.profile.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.weight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.$t('kg')))])]), _vm._v(" "), _c('div', {
    staticClass: "item spe-item"
  }, [_c('span', {
    class: {
      'es5': _vm.isEs || _vm.isIt || _vm.isPo || _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('birthday')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.birthdayShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('select', {
    staticClass: "weight",
    attrs: {
      "id": "dis_type"
    },
    domProps: {
      "value": _vm.profile.diabetes_type
    }
  }, [_c('option', {
    attrs: {
      "value": "DBTNF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBTNF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DBT1"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT1')))]), _c('option', {
    attrs: {
      "value": "DBT2"
    }
  }, [_vm._v(_vm._s(_vm.$t('DBT2')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTLADA"
    }
  }, [_vm._v(_vm._s(_vm.$t('LADA')))]), _c('option', {
    attrs: {
      "value": "DBTGEST"
    }
  }, [_vm._v(_vm._s(_vm.$t('Gestational')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DBTPRE"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prediabetes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTR"
    }
  }, [_vm._v(_vm._s(_vm.$t('Other')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isP),
      expression: "isP"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": _vm.disDateShow,
      "clearable": false,
      "picker-options": _vm.pickerOptions,
      "format": "dd/MM  yyyy"
    },
    model: {
      value: (_vm.profile.diabetes_diagonosis_date),
      callback: function($$v) {
        _vm.profile.diabetes_diagonosis_date = $$v
      },
      expression: "profile.diabetes_diagonosis_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "item"
  }, [_c('label', {
    staticClass: "spe-span"
  }, [_vm._v(_vm._s(_vm.$t('Profession')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.major),
      expression: "profile.major"
    }],
    staticClass: "profession",
    class: {
      'zh1': !_vm.isEn, 'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt, 'po1': _vm.isPo, fr1: _vm.isFr, 'sw1': _vm.isSw, 'cz1': _vm.isCz
    },
    attrs: {
      "id": "major"
    },
    domProps: {
      "value": _vm.profile.major
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.major = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DPRONF"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONF')))]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "",
      "value": "DPROENDOCRIN"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('DPROENDOCRIN')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIABTRA"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIABTRA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRONURSE"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRONURSE')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPRODIATIT"
    }
  }, [_vm._v(_vm._s(_vm.$t('DPRODIATIT')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DPROOTR"
    }
  }, [_vm._v("\t" + _vm._s(_vm.$t('DPROOTR')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "addSpan"
  }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }],
    staticClass: "address",
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.motto),
      expression: "profile.motto"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.motto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.motto = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "star",
    attrs: {
      "src": require("../../assets/icon_star.png")
    }
  }), _vm._v("    indicates a required field")])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('create')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b1e5bbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/HcpAddUser.vue
// module id = 1485
// module chunks = 7